import { render } from "./404.vue?vue&type=template&id=d2e3c7ee"
const script = {}

import "./404.vue?vue&type=style&index=0&id=d2e3c7ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__